import { useTranslation } from "react-i18next";
import edit from "./assets/pen-to-square-solid.svg";
import { PackingSlipModel } from "../../../dailyPlanning/domain/models/packingSlipModel";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { useEffect, useState } from "react";
import { updatePackingSlip } from "../../infrastructure/redux/PackingSlipThunks";
import Select from "react-select";
import { ReactSelectOptionType } from "../../../../../shared/types/reactSelectType";
import { packingSlipStatusLists } from "../../domain/lists/packingSlipStatusLists";

export const PackingSlipTableStatusRow = () => {
  const { t } = useTranslation("common");

  const dispatch = useAppDispatch();

  const model = useAppSelector((state) => state.crudMutate)
    .model as PackingSlipModel;

  const [isEdit, setIsEdit] = useState(false);

  const [status, setStatus] = useState("");

  useEffect(() => {
    setStatus(model.status ?? "");
  }, [model]);

  const packingSlipStatusListsOptions: { label: string; value: string }[] =
    packingSlipStatusLists.map((type) => {
      return { value: type, label: t(type) };
    });

  return (
    <tr className="packing-slip-comment">
      <td className="packing-slip-comment__label">{t("Status")}:</td>
      <td className="packing-slip-comment__value">
        {isEdit ? (
          <>
            <Select
              noOptionsMessage={() => {
                return t("No options");
              }}
              onChange={(options: unknown) => {
                const selectedOption = options as ReactSelectOptionType;
                setStatus(selectedOption.value);
              }}
              value={{ value: status, label: t(status ?? "") }}
              options={packingSlipStatusListsOptions}
              className={"entity-select"}
              classNamePrefix={"entity-select"}
            ></Select>

            <div className="d-flex justify-content-end mt-2 gap-2">
              <button
                className="btn btn-light btn-sm"
                onClick={() => {
                  setStatus(model.status ?? "");
                  setIsEdit(false);
                }}
              >
                {t("cancel")}
              </button>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  setIsEdit(false);

                  void dispatch(
                    updatePackingSlip({
                      id: parseInt(model.id),
                      data: {
                        status: status,
                      },
                      mutation: "upsertPackingSlip",
                    }),
                  );
                }}
              >
                {t("Save")}
              </button>
            </div>
          </>
        ) : (
          t(model.status ?? "")
        )}
      </td>
      {!isEdit && (
        <td className="packing-slip-comment__edit">
          <button onClick={() => setIsEdit(true)}>
            <img src={edit} alt={t("Edit")} width={16} />
          </button>
        </td>
      )}
    </tr>
  );
};
